
/* eslint-disable camelcase */
/* eslint-disable no-prototype-builtins */
/* eslint-disable promise/always-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable indent */
import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { ErrorToast } from '../../Components/Notification/Notification'
import toast from 'react-hot-toast'
import moment from 'moment'
import { MARKETING_OPTIONS, CURRENCY_OPTIONS, SELECT_OPTIONS } from './utils/data'
import Axios from '../../Config/Axios'
import { PrimaryButton, TextInput, Text } from '../../Components'
import {
    info,
    infoRed,

} from '../../Themes/Images'
import { colors } from '../../Themes'
import { useAuth } from '../../Global'
import { useStyles, selectStyles } from './Wrapper.styles'
import ReactGA from 'react-ga4'

const REGIONS_OPTIONS = [
    { value: 'London', label: 'London' },
    { value: 'Sydney', label: 'Sydney' },
    { value: 'Ohio', label: 'Ohio' },
    { value: 'Singapore', label: 'Singapore' }
]

function formatDate(date = new Date()) {
    const year = date?.toLocaleString('default', { year: 'numeric' })
    const month = date?.toLocaleString('default', { month: '2-digit' })
    const day = date?.toLocaleString('default', { day: '2-digit' })

    return [year, month, day].join('-')
}


const ConfirmSignupModal = ({ onSuccessSave }) => {
    const { getUpdatedUser } = useAuth()
    const classes = useStyles()
    const { logout, userAttributes } = useAuth()
    const [modalValues, setModalValues] = useState({
        location: '',
        apiKey: '',
        foundedFrom: null,
        foundedByOther: null,
        currency: { value: '', label: '', id: null },
        financial_year_end_date: '',
        financial_year_start_date: '',
        accountDomain: '',
        region: '',
        errors: {},
    })

    const [isLoading, setIsLoading] = useState(false)
    const [currentStep, setCurrentStep] = useState(1)
    const [isStep1Disabled, setIsStep1Disabled] = useState(false)
    const [isStep2Disabled, setIsStep2Disabled] = useState(false)

    const goToNextStep = () => {
        if (currentStep < 2) {
            setCurrentStep(currentStep + 1)
        }
    }
    const goToPreviousStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1)
        }
    }


    const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), 0, 1))
    const [endDate, setEndDate] = useState(new Date(new Date().getFullYear(), 0, 1))

    const startDateFormatted = formatDate(startDate)
    const endDateFormatted = formatDate(endDate)

    useEffect(() => {
        if (currentStep === 1) {
            if (
                modalValues?.location !== '' &&
                modalValues?.apiKey !== '' &&
                Object.keys(modalValues?.errors).length === 0
            ) {
                setIsStep1Disabled(false)
            } else {
                setIsStep1Disabled(true)
            }
        }
        // console.log(modalValues)
    }, [modalValues.location, modalValues.apiKey, modalValues?.errors])

    useEffect(() => {
        if (currentStep === 2) {
            if (
                modalValues?.currency?.value !== '' &&
                // modalValues?.financial_year_end_date !== '' &&
                // modalValues?.financial_year_start_date !== '' &&
                (userAttributes?.given_name !== 'practicehub' ||
                    (modalValues?.accountDomain !== '' && modalValues?.region !== ''))
            ) {
                setIsStep2Disabled(true)
            } else {
                setIsStep2Disabled(false)
            }
        }
    }, [currentStep, modalValues.currency, modalValues.accountDomain, modalValues.region])

    const handleChangeSelect = (selectedOption, key) => {
        setModalValues((prev) => ({
            ...prev,
            [key]: selectedOption,
        }))
    }

    const handleChangeApiKey = (value) => {
        setModalValues((prev) => ({
            ...prev,
            apiKey: value,
            errors: {},
        }))
    }
    const handleChangeAccountDomain = (value) => {
        setModalValues((prev) => ({
            ...prev,
            accountDomain: value,
            errors: {},
        }))
    }

    const timezoneValue = modalValues?.location?.value

    const getCountryFromTimezone = (timezone) => {
        if (!timezone) return ''
        return timezone.split('/')[0]
    }

    const countryValue = getCountryFromTimezone(timezoneValue)

    const onSave = () => {

        if (startDateFormatted > endDateFormatted) {
            toast.custom((t) => (
                <ErrorToast t={t} message='The fiscal year start date cannot be later than the end date.' />
            ))
            setIsLoading(false)
            return
        }

        setIsLoading(true)
        const data = {}
        data.apikey = modalValues?.apiKey
        data.country = countryValue
        data.timezone = timezoneValue
        // This will be used later - sending hardcoded data for the moment
        // data.financial_year_start_date = startDateFormatted
        // data.financial_year_end_date = endDateFormatted
        data.financial_year_start_date = moment().startOf('year').format('YYYY-MM-DD')
        data.financial_year_end_date = moment().endOf('year').format('YYYY-MM-DD')
        data.currency = modalValues?.currency?.value || ''
        data.chosenCurrency = modalValues?.currency?.label || ''
        // console.log(data)

        if (userAttributes?.given_name === 'practicehub') {
            data.accountDomain = modalValues?.accountDomain || ''
            data.region = modalValues?.region?.value || ''
        }

        if (modalValues?.foundedFrom?.value !== 'Other' && modalValues?.foundedFrom !== null) {
            data.marketing_source = modalValues?.foundedFrom?.value
        }

        if (modalValues?.foundedFrom?.value === 'Other') {
            if (modalValues?.foundedByOther?.trim()?.length > 0) {
                data.marketing_source = modalValues?.foundedByOther
            }
        }



        Axios.post(
            '/prod/user/trial',
            { ...data }
        )
            .then((r) => {
                ReactGA.event({
                    name: 'signup_complete',
                    params: {
                        method: 'Onboarding Modal',
                        plan: 'Free'
                    }
                })
                onSuccessSave()
                // eslint-disable-next-line promise/no-nesting
                getUpdatedUser().then((res) => {
                    // console.log('updated user', data)
                    setIsLoading(false)
                }).catch(e => console.log(e))
            })
            .catch((error) => {
                if (modalValues?.errors?.apiKey !== '') {
                    // console.log('Inside', modalValues?.errors?.apiKey)
                    setCurrentStep(1)
                    setIsLoading(false)
                    setModalValues((prev) => ({
                        ...prev,
                        errors: { apiKey: error?.response?.data?.message },
                    }))
                    return
                }
                toast.custom((t) => (
                    <ErrorToast t={t} message='Something went wrong. Please try again.' />
                ))
                setIsLoading(false)
                if (error.response) {
                    setModalValues((prev) => ({
                        ...prev,
                        errors: { apiKey: error?.response?.data?.message },
                    }))
                }
            })
    }

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    return (
        // <Modal costumizedPaperStyles={classes.paperCostum} opened={isVisible}>
        <div className={classes.ModalWrapper}>
            {currentStep === 2 &&
                <>
                    <div className={classes.inputContainer}>
                        {/* Will be used later */}
                        {/* <p
              style={{
                fontFamily: 'Roboto',
                fontWeight: '700',
              }}
            >
              Define the fiscal year for the metrics in the fiscal year tab
            </p>
            <div className={classes.dateRangePickerDivContainer}>
              <DateRangePickerDivided
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                callBack={() => null}
                isMobile={width < 600}
              />
            </div>
            {modalValues?.errors.financial_year_end_date && (
              <p className={classes.errorInput}>{modalValues?.errors.financial_year_end_date}</p>
            )} */}
                        {userAttributes?.given_name === 'practicehub' &&
                            <>
                                <p
                                    className={classes.onboardTitle}
                                >
                                    Write your Account Domain:
                                </p>
                                <TextInput
                                    costumizedInputStyles={
                                        classes['input_' + Boolean(modalValues?.errors?.accountDomain)]
                                    }
                                    error={modalValues?.errors?.accountDomain}
                                    value={modalValues?.accountDomain}
                                    setValue={handleChangeAccountDomain}
                                    name="accountDomain"
                                    label="Account domain"
                                    inputLabelStyle={{ fontSize: 16 }}
                                    required
                                />
                                {modalValues?.errors?.accountDomain && (
                                    <p className={classes.errorInput}>{modalValues?.errors?.accountDomain}</p>
                                )}
                                <p
                                    className={classes.onboardTitleRegion}
                                >
                                    Select the region:
                                </p>
                                <Select
                                    styles={selectStyles}
                                    label={<Text size='subnote' color='hsl(0, 0%, 50%)'>Region</Text>}
                                    placeholder="Region"
                                    value={modalValues?.region}
                                    options={REGIONS_OPTIONS}
                                    onChange={(e) => { handleChangeSelect(e, 'region') }}
                                    inputLabelStyle={{ fontSize: 16 }}
                                    required

                                />
                            </>
                        }
                        <p
                            className={classes.onboardTitleCurrency}
                        >
                            Select the currency your business operates in:
                        </p>
                        <Select
                            styles={selectStyles}
                            label={<Text size='subnote' color='hsl(0, 0%, 50%)'>Currency</Text>}
                            placeholder="Currency"
                            value={modalValues?.currency}
                            options={CURRENCY_OPTIONS}
                            onChange={(e) => { handleChangeSelect(e, 'currency') }}
                            inputLabelStyle={{ fontSize: 16 }}
                            required

                        />
                        {
                            <div
                                className={classes.onboardTitleNote}
                            >
                                <img
                                    style={{
                                        marginRight: 8,
                                    }}
                                    src={infoRed}
                                    alt="Nana"
                                />
                                <p
                                    className={classes.noteText}
                                >
                                    Note: You cannot change the currency afterward.
                                </p>
                            </div>
                        }

                    </div>
                    <div className={classes.divider} />
                    <div className={classes.buttonsWrapper}>
                        <PrimaryButton
                            className={classes.cancelButton}
                            onClick={goToPreviousStep}
                        >Back
                        </PrimaryButton>
                        <PrimaryButton
                            className={classes.nextButton}
                            loading={isLoading}
                            disabled={!isStep2Disabled || isLoading}
                            style={
                                !isStep2Disabled || isLoading
                                    ? { backgroundColor: colors.disabled, color: colors.white, height: 57 }
                                    : { backgroundColor: colors.primary, height: 57 }
                            }
                            type="submit"
                            onClick={onSave}
                        >
                            Finish
                        </PrimaryButton>
                    </div>
                </>
            }

            {currentStep === 1 &&
                <>
                    <div className={classes.inputContainer}>
                        <p
                            className={classes.onboardTitle}
                        >
                            PMS API Key
                        </p>

                        <TextInput
                            costumizedInputStyles={
                                classes['input_' + Boolean(modalValues?.errors?.apiKey)]
                            }
                            error={modalValues?.errors?.apiKey}
                            value={modalValues?.apiKey}
                            setValue={handleChangeApiKey}
                            name="apikey"
                            label="API Key"
                            inputLabelStyle={{ fontSize: 16 }}
                        />
                        {modalValues?.errors?.apiKey && (
                            <p className={classes.errorInput}>{modalValues?.errors?.apiKey}</p>
                        )}
                        {userAttributes?.given_name === 'Cliniko' && <div
                            className={classes.integrationNote}
                            onClick={() =>
                                openInNewTab(
                                    'https://help.cliniko.com/en/articles/1023957-generate-a-cliniko-api-key'
                                )
                            }
                        >
                            <img
                                className={classes.noteImage}
                                src={info}
                                alt="Nana"
                            />
                            <p
                                className={classes.noteText}
                            >
                                Click here to learn how to generate your {userAttributes?.given_name} API Key.
                            </p>
                        </div>}
                        {userAttributes?.given_name === 'practicehub' && <div
                            className={classes.integrationNote}
                            onClick={() =>
                                openInNewTab(
                                    'https://blog.dataplayer.io/connect-practicehub-to-your-dataplayer-account/'
                                )
                            }
                        >
                            <img
                                className={classes.noteImage}
                                src={info}
                                alt="Nana"
                            />
                            <p
                                className={classes.noteText}
                            >
                                Click here to learn how to generate your PracticeHub API Key.
                            </p>
                        </div>}
                        {userAttributes?.given_name === 'Nookal' && <div
                            className={classes.integrationNote}
                            onClick={() =>
                                openInNewTab(
                                    'https://www.nookal.com/help/connecting-nookal-to-dataplayer'
                                )
                            }
                        >
                            <img
                                className={classes.noteImage}
                                src={info}
                                alt="Nana"
                            />
                            <p
                                className={classes.noteText}
                            >
                                Click here to learn how to generate your {userAttributes?.given_name} API Key.
                            </p>
                        </div>}
                        <div
                            style={{
                                marginTop: 20,
                                marginBottom: 8
                            }}
                        >
                        </div>
                        <Select
                            styles={selectStyles}
                            label={<Text size='subnote' color='hsl(0, 0%, 50%)'>Location</Text>}
                            placeholder="Select your timezone"
                            value={modalValues?.location}
                            onChange={(e) => { handleChangeSelect(e, 'location') }}
                            options={SELECT_OPTIONS}
                            inputLabelStyle={{ fontSize: 16 }}

                        />
                        <div className={classes.discoverDP}>
                            <p
                                className={classes.discoverDPText}
                            >
                                How did you discover Dataplayer?
                            </p>
                            <p
                                className={classes.discoverDPTextOpt}
                            >
                                {'(optional)'}
                            </p>
                        </div>
                        <div className={classes.marketingInput}>
                            <Select
                                styles={selectStyles}
                                label={<Text size='subnote' color='hsl(0, 0%, 50%)'>Location</Text>}
                                placeholder="Select an option"
                                value={modalValues?.foundedFrom}
                                onChange={(e) => { handleChangeSelect(e, 'foundedFrom') }}
                                options={MARKETING_OPTIONS}
                            />
                            {modalValues?.foundedFrom?.value === 'Other' &&
                                <TextInput
                                    costumizedRootStyles={
                                        classes.otherInput
                                    }
                                    costumizedInputStyles={
                                        classes.specifyReason
                                    }
                                    error={Boolean(modalValues?.errors?.apiKey)}
                                    value={modalValues?.foundedByOther}
                                    setValue={(e) => {
                                        if (e?.length < 100) {
                                            handleChangeSelect(e, 'foundedByOther')
                                        }
                                    }}
                                    name="apikey"
                                    label="Please Specify"
                                />}
                        </div>
                    </div>
                    <div className={classes.divider} />
                    <div className={classes.buttonsWrapper}>
                        <PrimaryButton
                            className={classes.cancelButton}
                            onClick={logout}
                        >Log out
                        </PrimaryButton>
                        <PrimaryButton
                            className={classes.nextButton}
                            loading={isLoading}
                            disabled={isStep1Disabled || isLoading}
                            style={
                                isStep1Disabled || isLoading
                                    ? {
                                        backgroundColor: colors.disabled,
                                        color: colors.white,
                                        height: 57
                                    }
                                    : {
                                        backgroundColor: colors.primary,
                                        height: 57
                                    }
                            }
                            type="submit"
                            onClick={goToNextStep}
                        >
                            Next
                        </PrimaryButton>

                    </div>
                </>
            }
        </div>
        // </Modal>
    )
}

export default ConfirmSignupModal
